<template>
  <div class="amplify">
    <div class="normal" @click="isAmplify = true">
      <img :src="url" alt="" v-if="type === 'image'">
      <video :src="url" v-else-if="type === 'video'"></video>
      <img class="amplifyIcon" src="@/assets/icons/icon_amplify.png" alt="">
      <img class="play" v-if="type === 'video'" src="@/assets/icons/icon_play.png" @click.stop="playVideo" alt="">
    </div>
    <div class="amplifyContent" v-if="isAmplify" @click="reduce">
      <img :src="url" alt="" v-if="type === 'image'">
      <video @click.stop ref="video" controls :src="url" v-else-if="type === 'video'"></video>
      <img class="close" @click="reduce" src="@/assets/icons/icon_f@2x.png" alt="">
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      isAmplify: false
    }
  },
  props: {
    type: {
      type: String,
      default: 'image' // image video
    },
    url: {
      type: String,
      default: ''
    }
  },
  methods: {
    playVideo() {
      this.isAmplify = true
      this.$nextTick(() => {
        this.$refs.video.play()
      })
    },
    reduce() {
      this.isAmplify = false
    }
  },
  mounted () {
  }
}

</script>

<style scoped lang="less">
.amplify{
  width: 100%;
  height: 100%;
  .normal{
    width: 100%;
    height: 100%;
    position: relative;
    cursor: pointer;
    > img, > video{
      width: 100%;
      height: 100%;
    }
    .amplifyIcon{
      position: absolute;
      right: 7px;
      bottom: 5px;
      width: 14px;
      height: 14px;
      cursor: pointer;
    }
    .play{
      position: absolute;
      left: 50%;
      top: 50%;
      margin-left: -15px;
      margin-top: -15px;
      width: 30px;
      height: 30px;
    }
  }
  .amplifyContent{
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.65);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
    > img, > video{
      width: 80%;
      max-height: 80%;
      object-fit: contain;
      border-radius: 10px;
    }
    .close{
      position: absolute;
      right: 20px;
      top: 60px;
      width: 34px;
      height: 34px;
      cursor: pointer;
    }
  }
}
</style>
